import { render, staticRenderFns } from "./flowDirectionDetail.vue?vue&type=template&id=3608721c&scoped=true"
import script from "./flowDirectionDetail.vue?vue&type=script&lang=js"
export * from "./flowDirectionDetail.vue?vue&type=script&lang=js"
import style0 from "./flowDirectionDetail.vue?vue&type=style&index=0&id=3608721c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608721c",
  null
  
)

export default component.exports